import { PageHeader, Upload } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { isPlatformOrg } from 'domains/orgDomain';
import { useOrgId } from 'hooks/useOrg';
import { useTranslation } from 'react-i18next';

export const ParcelHeader = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const orgId = useOrgId();
  const isBaseOrg = isPlatformOrg({ id: orgId });
  const curItem = useAppSelector((state) => state.parcel.curItem);
  const filterObj = useAppSelector((state) => state.parcel.filterObj);
  const importLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.importParcels
  );
  const exportLoading = useAppSelector(
    (state) => state.loading.effects.excelDefinition.exportParcels
  );
  const currentPage = useAppSelector((state) => state.parcel.currentPage);

  const createButton = (
    <RevxButton
      key="create"
      brandGreen
      disabled={!!curItem}
      onClick={() => {
        dispatch.parcel.setState({
          curItem: {},
        });
      }}
    >
      {t('platform.parcel.createParcel')}
    </RevxButton>
  );

  const createFromBaseButton = (
    <RevxButton
      key="create_b"
      brandGreen
      onClick={() => {
        dispatch.parcel.updateBaseSelectVisible(true);
      }}
    >
      {t('platform.parcel.createParcelFromBase')}
    </RevxButton>
  );

  const createFromScratchButton = (
    <RevxButton
      key="create_s"
      brandGreen
      disabled={!!curItem}
      onClick={() => {
        dispatch.parcel.setState({
          curItem: {},
        });
      }}
    >
      {t('platform.parcel.createParcelFromScratch')}
    </RevxButton>
  );

  const importFile = (
    <Upload
      maxCount={1}
      disabled={importLoading}
      showUploadList={false}
      customRequest={async (option) => {
        const formData = new FormData();
        formData.append('file', option.file);
        await dispatch.excelDefinition.importParcels(formData);
        if (+currentPage === 1) {
          await dispatch.parcel.getParcels({
            page: {
              currentPage: 1,
              pageSize: 20,
            },
            query: {
              ...filterObj,
            },
          });
        } else {
          dispatch.parcel.setState({
            currentPage: 1,
          });
        }
      }}
    >
      <RevxButton key="import" brandGreen loading={importLoading}>
        {t('common.import')}
      </RevxButton>
    </Upload>
  );

  const exportFile = (
    <RevxButton
      key="export"
      brandGreen
      loading={exportLoading}
      onClick={() => {
        dispatch.excelDefinition.exportParcels();
      }}
    >
      {t('common.export')}
    </RevxButton>
  );

  return (
    <PageHeader
      ghost={false}
      title={
        isBaseOrg
          ? t('platform.header.baseParcels')
          : t('platform.header.parcels')
      }
      className="platform-page-header"
      extra={
        isBaseOrg
          ? [exportFile, importFile, createButton]
          : [
              exportFile,
              importFile,
              createFromBaseButton,
              createFromScratchButton,
            ]
      }
    />
  );
};
